import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { AboutBlockLayout } from '../AboutBlockLayout';
import { useSelector } from 'react-redux';
import { checkFsk, getContacts, getFullAddress } from '../../../../../selectors';
import { getWorkTime } from '../../../../../utils';

import { DeveloperContactItem } from './DeveloperContactItem';

import * as styles from './DeveloperContacts.css';

export const DeveloperContacts: React.FC = () => {
  const { workTime, website } = useSelector(getContacts);
  const fullAddress = useSelector(getFullAddress);
  const isFsk = useSelector(checkFsk);

  if (!isFsk) {
    return null;
  }

  const preparedWorkTime = getWorkTime(workTime);

  return (
    <AboutBlockLayout
      title="Контакты"
      content={
        <div className={styles['content-container']}>
          <DeveloperContactItem testId="CentralOffice" title="Центральный офис" content={fullAddress} />
          {preparedWorkTime && (
            <DeveloperContactItem testId="WorkTime" title="Режим работы" content={preparedWorkTime} />
          )}
          {website && (
            <DeveloperContactItem
              testId="DevelopersSite"
              title="Сайт застройщика"
              content={
                <a
                  className={styles['website-link-container']}
                  href={website.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {website.label}
                  <IconActionArrowUpRight16 color="icon-main-default" />
                </a>
              }
            />
          )}
        </div>
      }
      testId="DeveloperContacts"
    />
  );
};
